import React from "react";

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-4 py-6">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6">
        <h1 className="text-2xl font-bold text-indigo-700 mb-4">Support & Help</h1>
        <p className="text-gray-700 mb-2">
          If you are facing any issues or need assistance, feel free to reach out to us.
        </p>
        <div className="mt-4">
          <h2 className="text-lg font-semibold">Contact Information:</h2>
          <p className="text-gray-600 mt-1">
            Name: <span className="font-medium">PairLingo</span>
          </p>
          <p className="text-gray-600">
            Email for any help or issues:{" "}
            <a href="mailto:support@pairlingo.com" className="text-indigo-600 underline">
              support@pairlingo.com
            </a>
          </p>
        </div>
        <p className="text-gray-500 mt-4">
          We are here to assist you and make your language learning journey smoother!
        </p>
      </div>
    </div>
  );
};

export default Support;